import { fetchSmartyAutocomplete } from "./providers/smarty/smartyAutocomplete";

/**
 * Dispatches an autocomplete query to the active provider.
 *
 * Today there is only one provider (Smarty, US-only). Non-US queries get
 * `[]` because the autocomplete UI is US-shaped and the Smarty
 * international product is a separate SKU. When intl autocomplete becomes
 * a product requirement, route by country here.
 *
 * The raw fetch lives in `providers/smarty/smartyFetch.js`. Tests and
 * Storybook alias that single file to `testUtils/MockSmartyFetch`; in
 * dev with REACT_APP_ADDRESS_VALIDATION_LIVE=false, smartyFetch itself
 * delegates to MockSmartyFetch via dynamic import. All three share the
 * same fixture file in Smarty's real response shape, and the mapper in
 * `smartyAutocomplete.js` runs identically in all environments.
 *
 * @param {string} query
 * @param {string} [country="US"] - ISO 3166-1 alpha-2.
 * @param {{ signal?: AbortSignal, city?: string }} [options] - `city` is the
 *   user's typed city, threaded through so the provider can compose it into
 *   the `search` (street + city) and surface a mailable alternate city.
 * @returns {Promise<Array<import("./providers/smarty/smartyAutocomplete").CandidateAddress>>}
 */
export const fetchAutocompleteSuggestions = async (
  query,
  country = "US",
  options = {}
) => fetchSmartyAutocomplete(query, country, options);
